<mat-icon
  [matTooltip]="myTooltip"
  (click)="onClick()">
  <span i18n>info</span>
</mat-icon>

